import React from "react";
import "../Healthcare.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";
import {
    FiHome,
    FiChevronRight,
    FiHeart,
} from "react-icons/fi";

const Healthcare = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                            HERO SECTION
            ===================================================== */}

            <section className="healthcare-hero">

                <div className="healthcare-overlay"></div>

                <div className="container">

                    <div className="healthcare-hero-content">

                        <span className="healthcare-tag">
                            Healthcare Technology Solutions
                        </span>

                        <h1>
                            Transforming
                            <span> Healthcare Services </span>
                            Through Smart Digital Innovation
                        </h1>

                        <p>
                            Kishancart Digital (OPC) Private Limited empowers
                            hospitals, clinics, diagnostic centers, pharmacies,
                            and healthcare providers with secure, scalable, and
                            intelligent digital solutions. We develop modern
                            healthcare platforms that simplify hospital
                            management, improve patient care, automate
                            operations, and ensure seamless communication
                            between healthcare professionals and patients.
                        </p>

                        <div className="healthcare-hero-btns">

                            {/* <NavLink
                                to="/contact"
                                className="primary-btn"
                            >
                                Contact Us
                            </NavLink>

                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >
                                Explore Services
                            </NavLink> */}

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}

            <section className="healthcare-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span>Solutions</span>

                        <FiChevronRight />

                        <span className="active">
                            <FiHeart />
                            Healthcare
                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                Healthcare Overview + Challenges
            ===================================================== */}

            {/* =====================================================
                        HEALTHCARE OVERVIEW
            ===================================================== */}

            <section className="healthcare-overview">

                <div className="container">

                    <div className="overview-grid">

                        {/* LEFT CONTENT */}

                        <div className="overview-content">

                            <span className="section-tag">
                                Digital Healthcare Solutions
                            </span>

                            <h2>
                                Smart Technology for
                                <span> Modern Healthcare</span>
                            </h2>

                            <p>
                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable healthcare
                                technology solutions that simplify hospital
                                operations, improve patient engagement, and
                                enhance healthcare service delivery. Our
                                solutions help healthcare providers manage
                                patients, appointments, billing, pharmacies,
                                laboratories, and medical records from one
                                integrated platform.
                            </p>

                            <p>
                                Whether you operate a hospital, clinic,
                                diagnostic laboratory, pharmacy, or healthcare
                                startup, our customized software solutions are
                                designed to improve operational efficiency,
                                ensure data security, and deliver a better
                                experience for both patients and healthcare
                                professionals.
                            </p>

                            <div className="overview-list">

                                <div className="overview-item">
                                    ✓ Hospital Management System
                                </div>

                                <div className="overview-item">
                                    ✓ Appointment Scheduling
                                </div>

                                <div className="overview-item">
                                    ✓ Electronic Medical Records (EMR)
                                </div>

                                <div className="overview-item">
                                    ✓ Pharmacy & Inventory Management
                                </div>

                                <div className="overview-item">
                                    ✓ Laboratory Management
                                </div>

                                <div className="overview-item">
                                    ✓ Patient Portal & Mobile Apps
                                </div>

                            </div>

                        </div>

                        {/* RIGHT CARDS */}

                        <div className="overview-cards">

                            <div className="overview-card">

                                <h3>Hospital Management</h3>

                                <p>
                                    Streamline hospital operations with a centralized platform for patient registration, OPD/IPD management, billing, administration, and real-time reporting—improving efficiency, accuracy, and patient care.
                                </p>

                            </div>

                            <div className="overview-card">

                                <h3>Patient Experience</h3>

                                <p>
                                    Enable online appointments, digital
                                    prescriptions, patient portals, and
                                    real-time communication to improve patient
                                    satisfaction.
                                </p>

                            </div>

                            <div className="overview-card">

                                <h3>Healthcare Automation</h3>

                                <p>
                                    Automate appointments, laboratory reports,
                                    pharmacy inventory, billing, and daily
                                    administrative workflows.
                                </p>

                            </div>

                            <div className="overview-card">

                                <h3>Healthcare Analytics</h3>

                                <p>
                                    Access real-time reports and dashboards to
                                    monitor hospital performance, patient data,
                                    revenue, and operational efficiency.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    HEALTHCARE CHALLENGES
            ===================================================== */}

            <section className="healthcare-challenges">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Industry Challenges
                        </span>

                        <h2>
                            Challenges in
                            <span> Healthcare Management</span>
                        </h2>

                        <p>
                            Healthcare organizations face increasing demands
                            for operational efficiency, patient safety, data
                            security, and seamless communication. Our digital
                            solutions help overcome these challenges with
                            modern, scalable technology.
                        </p>

                    </div>

                    <div className="challenge-grid">

                        <div className="challenge-card">

                            <h3>Patient Record Management</h3>

                            <p>
                                Securely organize and access patient medical
                                records, treatment history, and healthcare
                                documents from one centralized system.
                            </p>

                        </div>

                        <div className="challenge-card">

                            <h3>Appointment Scheduling</h3>

                            <p>
                                Simplify appointment booking and reduce waiting
                                times with automated scheduling and reminders.
                            </p>

                        </div>

                        <div className="challenge-card">

                            <h3>Hospital Administration</h3>

                            <p>
                                Streamline daily hospital operations including
                                admissions, billing, departments, and staff
                                management.
                            </p>

                        </div>

                        <div className="challenge-card">

                            <h3>Pharmacy Operations</h3>

                            <p>
                                Manage medicine inventory, prescriptions, stock
                                availability, and supplier coordination with
                                ease.
                            </p>

                        </div>

                        <div className="challenge-card">

                            <h3>Laboratory Coordination</h3>

                            <p>
                                Automate laboratory workflows, diagnostic
                                reports, and patient test management for
                                improved efficiency.
                            </p>

                        </div>

                        <div className="challenge-card">

                            <h3>Data Security & Compliance</h3>

                            <p>
                                Protect sensitive healthcare information with
                                secure infrastructure, controlled access, and
                                compliance-ready digital systems.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE

                Healthcare Solutions
                +
                Key Features

            ===================================================== */}

            {/* =====================================================
                        OUR HEALTHCARE SOLUTIONS
            ===================================================== */}

            <section className="healthcare-solutions">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Healthcare Solutions
                        </span>

                        <h2>
                            Comprehensive Digital Solutions for
                            <span> Healthcare Providers</span>
                        </h2>

                        <p>
                            We develop secure, scalable, and intelligent healthcare
                            software that improves patient care, streamlines hospital
                            operations, and enables healthcare organizations to deliver
                            better services through digital innovation.
                        </p>

                    </div>

                    <div className="solutions-grid">

                        <div className="solution-card">

                            <h3>Hospital Management System</h3>

                            <p>
                                Digitally manage patient registration, admissions,
                                billing, departments, staff, and hospital operations
                                from a centralized platform.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Electronic Medical Records (EMR)</h3>

                            <p>
                                Securely store, manage, and access patient medical
                                history, prescriptions, laboratory reports, and
                                treatment records.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Telemedicine Platform</h3>

                            <p>
                                Enable virtual consultations, online appointments,
                                digital prescriptions, and secure communication between
                                doctors and patients.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Appointment Management</h3>

                            <p>
                                Simplify appointment scheduling with automated booking,
                                reminders, calendar management, and queue optimization.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Pharmacy Management</h3>

                            <p>
                                Manage medicine inventory, suppliers, prescriptions,
                                stock alerts, and pharmacy billing with ease.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Laboratory Information System</h3>

                            <p>
                                Automate laboratory workflows, sample tracking, report
                                generation, and diagnostic management efficiently.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Patient Mobile App</h3>

                            <p>
                                Allow patients to book appointments, view reports,
                                access prescriptions, and receive healthcare updates
                                anytime.
                            </p>

                        </div>

                        <div className="solution-card">

                            <h3>Healthcare Analytics Dashboard</h3>

                            <p>
                                Monitor hospital performance, patient statistics,
                                revenue, and operational insights through real-time
                                analytics dashboards.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        KEY FEATURES
            ===================================================== */}

            <section className="healthcare-features">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Key Features
                        </span>

                        <h2>
                            Everything Needed for a
                            <span> Modern Healthcare Platform</span>
                        </h2>

                        <p>
                            Our healthcare solutions include powerful features
                            designed to improve patient care, streamline
                            administration, and enhance operational efficiency.
                        </p>

                    </div>

                    <div className="features-grid">

                        <div className="feature-card">
                            <h3>Online Appointment Booking</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Electronic Health Records</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Doctor Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>OPD & IPD Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Pharmacy Inventory</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Laboratory Reports</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Digital Prescriptions</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Billing & Insurance</h3>
                        </div>

                        <div className="feature-card">
                            <h3>SMS & Email Notifications</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Patient Portal</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Multi-Branch Support</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Secure Cloud Hosting</h3>
                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE

                    Business Benefits
                    +
                    Footer

            ===================================================== */}

            {/* =====================================================
                        BUSINESS BENEFITS
            ===================================================== */}

            <section className="healthcare-benefits">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Business Benefits
                        </span>

                        <h2>
                            Why Healthcare Organizations Choose
                            <span> Kishancart Digital</span>
                        </h2>

                        <p>
                            Our healthcare technology solutions help hospitals,
                            clinics, diagnostic centers, and healthcare providers
                            deliver better patient care while improving operational
                            efficiency, reducing costs, and ensuring secure digital
                            healthcare management.
                        </p>

                    </div>

                    <div className="benefits-grid">

                        <div className="benefit-card">

                            <h3>Enhanced Patient Care</h3>

                            <p>
                                Deliver faster, more personalized healthcare
                                services with digital patient records, online
                                appointments, and seamless communication between
                                patients and healthcare professionals.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Improved Operational Efficiency</h3>

                            <p>
                                Automate hospital administration, appointment
                                scheduling, billing, pharmacy operations, and
                                laboratory workflows to reduce manual effort.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Secure Medical Records</h3>

                            <p>
                                Protect sensitive patient information with
                                secure cloud infrastructure, role-based access,
                                encrypted storage, and reliable data backup.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Data-Driven Decision Making</h3>

                            <p>
                                Gain valuable insights into hospital performance,
                                patient trends, financial reports, and resource
                                utilization through real-time analytics.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Scalable Healthcare Platform</h3>

                            <p>
                                Easily expand your healthcare services across
                                multiple clinics, hospitals, pharmacies, and
                                diagnostic centers using a centralized platform.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Future-Ready Digital Healthcare</h3>

                            <p>
                                Adopt modern technologies such as telemedicine,
                                mobile healthcare applications, cloud computing,
                                and automation to support long-term digital
                                transformation.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default Healthcare;